import { LogicalFieldMixin } from './mixins.js';

const LogicalFile = {
  mixins: [LogicalFieldMixin],

  template: `
    <div class="form-field-input">
      <button class="btn-default" disabled>
        <span>选择文件</span>
        <i class="slp-upload-o"></i>
      </button>
    </div>
  `
};

export default LogicalFile;
